import { Flex } from 'antd';
import Icon from '@ant-design/icons';
import { downSVG } from '../media/icons';
import setImageAbsoluteUrl from "../utils/setImageAbosulteUrl";
import { marketsDir } from '../utils/routeUtils';

const DownIcon = (props) => <Icon component={downSVG} {...props} />;

const Navbar = ({ menu, lang }) => {
  const menuForLanguage = menu.find(item => item[lang]);
  const menuItems = menuForLanguage[lang];
  const marketKey = marketsDir(lang);
  return (
  <nav className="header-menu">
    <ul className="menu">
      {menuItems.map((item, index) => {
        const isMarkets = item.label.toLowerCase() === marketKey;
        return (
        
        <li key={index} className="menu-item bt-small-400">
          <a className="menu-link"
            // href={item.url}
            {...(item.url ? { href: item.url } : {})}
            
          >
            {item.label}
            <DownIcon 
              fill={'#0027F9'}
              style={{
                fontSize: '16px',
                marginRight: '5px',
                color: '#0027F9'
              }} />
          </a>
          {item?.children.length > 0 && (
            <Flex className='menu-content'>
              <Flex className="menu-content-left">
                <div style={{ alignSelf: 'center' }}>
                  <img loading="lazy" src={setImageAbsoluteUrl(item?.logo?.mediaItemUrl)} className="menu-logo"/>
                </div>
                <span className="menu-content-left-title">{item.label}</span>
                <p className="menu-description">{item?.description}</p>
              </Flex>
              <Flex className="menu-content-right" direction="column" style={{ gap: '32px' }}>
                {isMarkets ? (
                  item.children.map(regionMenu => (
                    <div key={regionMenu.label} className="region-block">
                      {/* <li key={regionMenu.url} className="submenu-item bt-small-400"> */}
                        <a className="submenu-item submenu-link bt-small-400" href={regionMenu.url} 
                          style={{ padding: '8px 0px', fontWeight: '600' }}
                        >
                          {regionMenu.label}
                        </a>
                      {/* </li> */}
                      <ul className="region-grid">
                        {regionMenu.children.map(child => (
                          <li key={child.url} className="submenu-item bt-small-400">
                            <a className="submenu-link" href={child.url}>
                              {child.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))
                ) : (
                  <ul className="submenu">
                    {item.children.map(child => (
                      <li key={child.url} className="submenu-item bt-small-400">
                        <a className="submenu-link" href={child.url}>
                          {child.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </Flex>
            </Flex>
          )}
        </li>
      )})}
    </ul>
  </nav>
)}

export default Navbar;
